export default {
    computed: {
        isSharedTrackingPage() {
            return this.$route.path.indexOf('/track') > -1
        },
    },
}
